import { DetailPageLayout, createDefaultDetailPageTitleFn } from '@app/DetailPageLayout';
import { Link } from 'react-router-dom';
import './Report.scss';
import { useNavigate } from '@routes/routes.hooks';
import { routes } from '@routes/routes.models';
import { useReportList } from './report.hooks';

export const ReportList = () => {
  const { navigate } = useNavigate();

  const reportList = useReportList();
  return (
    <DetailPageLayout
      isGlobalPage
      errorGetDetail={null}
      isDrawer={false}
      isRestricted={false}
      data="placeholder"
      isLoading={false}
      isRefetching={false}
      title={createDefaultDetailPageTitleFn('Reports')}
      breadcrumb={[
        {
          text: 'Home',
          prefixIconName: 'House',
          onClick: () => {
            navigate(routes.home.path);
          },
        },
        {
          text: 'Reports',
          prefixIconName: 'Clipboard2Data',
          active: true,
        },
      ]}
      render={() => {
        return (
          <>
            {reportList.map((r) => {
              return (
                <Link key={`report-${r.type}-link`} to={r.route} className="gcl-gems-report-list-link">
                  {r.name}
                </Link>
              );
            })}
          </>
        );
      }}
    />
  );
};
